import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { alpha, styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { TiArrowBack } from "react-icons/ti";
import Add from "../../../icons/add.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { getOneAAFF, getProveedor, sendEmailDocsCad } from "../../../services";
import { cambiarFormatoNombre, daysDiff, editarComentario, eliminarComentario, fijarComentario } from "../../../functions/funciones";
import { withRouter } from "../../../providers/withRouter";
import Editar from "../../../icons/editar.svg";
import {
  subirDocumentacionProveedor,
  subirDeclaracionResponsable,
  validarDocumentacion,
  verDocumentacion,
  verDeclRes,
  validarDeclRes,
} from "./../../../providers/documentos";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ModalEditar from "./editarDatosProv";
import { DialogoSubirDocumentacion } from "../../../providers/Dialogos";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { UsuarioContext } from "../../../providers/userContext";
import Delegations from "../../../components/suppliers/delegations";
import { createComment } from "../../../services/comment.service";
import ModalEditarComentarios from "./../../../components/suppliers/AllComments";
import ControlledAccordions from "./accAAFFCom";
import Trabajadores from "../../../components/suppliers/Trabajadores";
import Comentarios from "../../../components/proveedores/comentarios";
import ReclamacionesTimeline from "../../../components/proveedores/ReclamacionesTimeline";
import { getReclamacionesProveedor } from "../../../services/proveedor.service";
import Excel from "../../../icons/excel.svg"
import { getAaffSuppExcel } from "../../../services/aaffs.service";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FF5252",
    "&:hover": {
      backgroundColor: alpha("#FF5252", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FF5252",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#7bc977",
    backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    "&:hover": {
      backgroundColor: alpha("#7bc977", theme.palette.action.hoverOpacity),
    },
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#7bc977",
  },
}));

const CustomPendienteSwitch = styled(Switch)(({ theme }) => ({
  "& .MuiSwitch-switchBase": {
    color: "#FFD700",
  },
  "& .MuiSwitch-switchBase + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "#FFD700",
    backgroundColor: alpha("#FFD700", theme.palette.action.hoverOpacity),
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#FFD700",
  },
}));

const Proveedor = (props) => {
  // const delegations = 1;
  const { t } = useTranslation(['suppliers', 'common', 'properties']);
  const user = useContext(UsuarioContext);
  const [aaff, setAaff] = useState({});
  const [proveedor, setProveedor] = useState({});
  const [fincas, setFincas] = useState([]);
  const [modalEditarOpened, setModalEditarOpened] = useState(false);
  const [modalCommentsOpened, setModalCommentsOpened] = useState(false);
  const [recargar, setRecargar] = useState(false);
  const [open, setOpen] = useState(0);
  const [dialog, setDialog] = useState({});
  const [comentarios, setComentarios] = useState([]);
  const [comentario, setComentario] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [loadingXls, setLoadingXls] = useState(false);
  const [reclamaciones, setReclamaciones] = useState([]);
  const [loadingReclamaciones, setLoadingReclamaciones] = useState(true);
  const hijoAPadre = () => {
    setRecargar(!recargar);
  };
  useEffect(() => {
    fetchData();
  }, [!recargar]);

  useEffect(() => {
    if (!proveedor?.id) return;
    setLoadingReclamaciones(true);
    getReclamacionesProveedor(proveedor.id)
      .then((res) => setReclamaciones(Array.isArray(res) ? res : []))
      .catch(() => setReclamaciones([]))
      .finally(() => setLoadingReclamaciones(false));
  }, [proveedor?.id]);

  const fetchData = async () => {
    const res = await getOneAAFF(props.params.nifAAFF)

    setAaff(res);
    setFincas(res?.properties);

    const resProv = await getProveedor(props.params.nifProveedor)
    setProveedor(resProv);

    const comments = resProv?.comments?.length > 0 ? resProv?.comments?.map(comment => {
      comment.usuario = comment.user?.consultant?.[0] || comment.user?.admin?.[0]  || comment.user?.technician?.[0];
      return comment
    }).sort((a, b) => {
      // Primero ordenar por fijado (true primero)
      if (a.fijado && !b.fijado) return -1;
      if (!a.fijado && b.fijado) return 1;
      // Si ambos tienen el mismo estado de fijado, ordenar por createdAt (más reciente primero)
      return new Date(b.createdAt) - new Date(a.createdAt);
    }) : [];
    setComentarios(comments);
    setIsLoading(false);
  }

  const mostrarPanel = (data) => {
    setDialog({
      opened: true,
      title: data.title,
      docName: data.nombreDoc,
      fechaCaducidad: undefined,
      fecha: undefined,
    });
    setOpen(data.open);
  };

  const handleSubirDocsCallback = () => {
    setRecargar(!recargar);
  };

  const comprobarArchivos = async (validado, status, ruta, id, idDoc, rol, nif, noProcede = false) => {
    // Llama a la función importada y pasa la devolución de llamada
    if (validado && status) {
      verDocumentacion(ruta, id, idDoc, rol, nif, noProcede).then((resultado) => {
        handleSubirDocsCallback(resultado)
      })
    } else {
      subirDocumentacionProveedor(ruta, id, idDoc, rol, nif, noProcede).then((resultado) => {
        handleSubirDocsCallback(resultado)
      })
    }
  };

  const comprobarValidacion = async (ruta, id, nif, idtypeDoc) => {
    validarDocumentacion(ruta, id, nif, idtypeDoc).then((resultado) => {
      handleSubirDocsCallback(resultado);
    });
  }

  const editarComment = async (id, comm) => {
    editarComentario(id, user.id, comm).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }
  const eliminarComment = async (id) => {
    eliminarComentario(id).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  }
  const fijarComment = async (id, fijado) => {
    fijarComentario(id, fijado).then((resultado) => {
      handleSubirDocsCallback(resultado)
    })
  };
  const generateComunidadesExcel = async () => {
    console.log(props.params);
    const { nifAAFF, nifProveedor } = props.params;
    const toastId = toast.loading(t('excel.generating'));
    setLoadingXls(true);
    try {
      const data = await getAaffSuppExcel(nifAAFF, nifProveedor);
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `comunidades_proveedor_${nifProveedor}_${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
      toast.update(toastId, {
        render: t('excel.downloadSuccess'),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      setLoadingXls(false);
    } catch (error) {
      console.log(error);
      toast.update(toastId, {
        render: t('excel.downloadError'),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });
      setLoadingXls(false);
    }
  };
  function guardarComentarios() {
    try {
      let infoComentario = {
        prop_id: null,
        supp_id: proveedor.id,
        aaff_id: null,
        texto: comentario,
        tipo: "comment",
        status: 1,
      }
      createComment(infoComentario).then(res => {
        handleSubirDocsCallback(res)
        setComentario('')
      })
    } catch (error) {
      console.log(error)
    }

  }
  const handleSendEmail = async () => {
    const { nifProveedor } = props.params;
    return new Promise(async (resolve, reject) => {
      try {
        const result = await Swal.fire({
          title: t('email.sendExpiredDocsTitle'),
          text: t('email.sendExpiredDocsText'),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#33dd75",
          cancelButtonColor: "#888",
          confirmButtonText: t('email.send'),
          cancelButtonText: t('common:actions.cancel'),
        });

        if (result.isConfirmed) {
          const toastInfo = toast.info(
            t('email.sending'),
            { autoClose: false }
          );

          await sendEmailDocsCad(
            user.id,
            nifProveedor,
            aaff.razonSocial,
            proveedor.user.email
          )
            .then((res) => {
              res.forEach((item) => {
                if (item.status === 200) {
                  toast.update(toastInfo, {
                    render: item.msg,
                    type: toast.TYPE.SUCCESS,
                    autoClose: true,
                  });
                  resolve(true);
                } else {
                  toast.update(toastInfo, {
                    render: item.msg,
                    type: toast.TYPE.ERROR,
                    autoClose: true,
                  });
                }
              });
            })
            .catch((error) => {
              console.log(error);
              toast.update(toastInfo, {
                render: t('email.sendError'),
                type: toast.TYPE.ERROR,
                autoClose: true,
              });
              reject(error);
            });
        } else {
          resolve(false);
        }
      } catch (error) {
        console.error("Error al enviar email:", error);
        reject(error);
      }
    });
  };
  function cambiarComentarios(evt) {
    const value = evt.target.value;
    setComentario(value);
  }

  const redirectToSomeRoute = (nif) => {
    setIsLoading(true)
    setRecargar(!recargar)
    props.navigate(`/proveedores/${nif}`);
  }

  const comprobarDeclRes = async (nifProv, id, nifAAFF, ruta, idDeclRes, validado, status) => {
    // Llama a la función importada y pasa la devolución de llamada
    if (validado && status) {
      verDeclRes(nifProv, id, nifAAFF, ruta, idDeclRes).then((resultado) => {
        handleSubirDocsCallback(resultado)
      })
    } else {
      subirDeclaracionResponsable(nifProv, id, ruta, idDeclRes).then((resultado) => {
        handleSubirDocsCallback(resultado)
      })
    }
  };
  const comprobarValDeclRes = async (ruta, idDeclRes, nifAAFF) => {

    validarDeclRes(ruta, idDeclRes, nifAAFF).then((resultado) => {

      handleSubirDocsCallback(resultado)
    })
  };

  return isLoading ? <CircularProgress style={{ color: '#92004D', position: 'absolute', top: '50%', left: '50%' }} /> :
    <>
      <ModalEditarComentarios
        comentarios={comentarios}
        opened={modalCommentsOpened}
        eliminarComment={eliminarComment}
        editarComment={editarComment}
        fijarComment={fijarComment}
        handleClose={() => {
          setModalCommentsOpened(false);
          setRecargar(!recargar);
        }}
      />
      <ModalEditar
        proveedor={proveedor}
        opened={modalEditarOpened}
        hijoAPadre={hijoAPadre}
        handleClose={() => {
          setModalEditarOpened(false);
          setRecargar(!recargar);
        }}
      />
      <BreadCrumb rutas={[{ path: '/aaff', label: t('common:commercials.columns.propertyManagers') }, { path: `/aaff/${aaff?.nif}/comunidades`, label: `${aaff?.razonSocial}` }, { path: `/aaff/${aaff?.nif}/proveedores`, label: t('title').toLowerCase() }, { path: `/aaff/${aaff?.nif}/proveedores/${proveedor?.nif}`, label: `${proveedor?.razonSocial}` }]} style={{ margin: '0 10px' }} />
      <div className="pageGrid">
        <div className="gridCard">
          <div className="gridHead">
            {t('sections.generalInfo')}
            <Link to={`/aaff/${aaff?.nif}/proveedores`}>
              <div className="gridHeadRight">
                {/* {"<< volver al listado de Proveedores"} */}
                <TiArrowBack style={{ fontSize: 23 }} />
              </div>
            </Link>
          </div>
          <div className="gridSubhead editarSubhead">
            <div>{t('sections.companyData')}</div>
            <div
              className="editarBtn"
              onClick={() => setModalEditarOpened(true)}
            >
              <span style={{ marginRight: 10 }}>{t('common:actions.edit')}</span>{" "}
              <img src={Editar} alt={t('common:actions.edit')} />
            </div>
          </div>
          <div className="datosGrid">
            <p>
              <b>{t('detail.supplierName')}</b> {proveedor?.razonSocial}
            </p>
            <p>
              <b>{t('detail.address')}</b> {proveedor?.direccion}
            </p>
            <p>
              <b>{t('detail.nif')}</b> {proveedor?.nif}
            </p>
            <p>
              <b>{t('detail.municipality')}</b> {cambiarFormatoNombre(proveedor?.municipio)}
            </p>
            <p>
              <b>{t('detail.contactPerson')}</b> {proveedor?.nombreContacto}
            </p>
            <p>
              <b>{t('detail.postalCode')}</b> {proveedor?.codigoPostal}
            </p>
            <p>
              <b>{t('detail.contactEmail')}</b> {proveedor?.emailContacto}
            </p>
            <p>
              <b>{t('detail.province')}</b> {proveedor?.provincia}
            </p>
            <p>
              <b>{t('detail.loginEmail')}</b> {proveedor?.user?.email}
            </p>
            <p>
              <b>{t('detail.phone')}</b> {proveedor?.telefonoContacto}
            </p>
            <p>
              <b>{t('detail.createdAt')}</b>{" "}
              {new Date(proveedor?.createdAt).toLocaleDateString()}
            </p>
            <p>
              <b>{t('detail.lastReclamation')}</b>{" "}
              {proveedor?.ultimaReclamacion === undefined ||
                proveedor?.ultimaReclamacion === null
                ? new Date(proveedor?.createdAt).toLocaleDateString()
                : new Date(proveedor?.ultimaReclamacion).toLocaleDateString()}
            </p>
          </div>
          <div className="datosGrid">
            <div></div>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                onClick={() => handleSendEmail()}
                style={{
                  margin: "10px 0",
                  borderRadius: "5px 5px",
                  backgroundColor: "#92004D",
                  color: "#ffffff",
                  padding: "5px 10px",
                }}
              >
                {t('email.expiredDocs')}
              </button>
            </div>
          </div>
          {user.rol === "AAFF" && (
            <div style={{ margin: "10px 20px" }}>
              <ReclamacionesTimeline fechas={reclamaciones} loading={loadingReclamaciones} t={t} />
            </div>
          )}
          <div className="datosGrid">
            <Comentarios supp={proveedor} />
          </div>
          <div className="gridSubhead">{t('sections.companyDocuments')}</div>
          <div className="tableContainer">
            <table>
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.rc')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.preventiveModality')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.riskAssessment')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.preventivePlanning')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.workersList')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.rlc')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.rnt')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.socialSecurityCert')}</th>
                  <th style={{ textAlign: "center" }}>{t('documentTypes.responsibleDeclaration')}</th>
                </tr>
              </thead>
              <tbody>
                {<tr>
                  {/* RC */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                      ?.pendiente &&
                      proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                        ?.status ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                            ?.validado &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                            ?.status
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                              ?.id,
                            2,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>
                      {proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                        ?.fechaCaducidad !== null &&
                        proveedor?.docssupps?.find((d) => d.tipoDoc === 2)
                          ?.status ? (
                        <span
                          style={{
                            color:
                              daysDiff(
                                new Date(
                                  proveedor?.docssupps?.find(
                                    (d) => d.tipoDoc === 2
                                  )?.fechaCaducidad
                                ),
                                new Date()
                              ) > 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {new Date(
                            proveedor?.docssupps?.find(
                              (d) => d.tipoDoc === 2
                            )?.fechaCaducidad
                          ).toLocaleDateString()}
                        </span>
                      ) : (
                        "-"
                      )}
                    </small>
                  </td>
                  {/* Modalidad preventiva */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.validado,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.status,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.id,
                                3,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 3)
                              ?.fechaCaducidad !== undefined ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 3
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 3
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Evaluación de riesgos*/}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                      ?.pendiente ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                            ?.validado
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 5)
                              ?.id,
                            5,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>-</small>
                  </td>
                  {/* Planificación preventiva */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.validado,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.status,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.ruta,
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.id,
                                4,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 4)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 4
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 4
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Trabajadores */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                          ?.pendiente ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                ?.validado
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 10)
                                  ?.id,
                                10,
                                user.rol,
                                proveedor.nif
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>-</small>
                      </>
                    )}
                  </td>
                  {/* RLC */}
                  <td style={{ textAlign: "center", width: '13%' }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : proveedor?.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede === true || proveedor?.docssupps?.find((d) => d.tipoDoc === 9)?.noProcede === 1 ? (
                      <span style={{ color: "#000" }}>{t('detail.notApplicable')}</span>
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                          ?.pendiente &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                            ?.status ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                ?.validado &&
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                ?.status
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                                  ?.id,
                                9,
                                user.rol,
                                proveedor.nif,
                                proveedor?.noProcede
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 9)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 9
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 9
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/*  RNT */}
                  <td style={{ textAlign: "center", width: '13%' }}>
                    {proveedor?.noProcede ? (
                      t('detail.notApplicable')
                    ) : proveedor?.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede === true || proveedor?.docssupps?.find((d) => d.tipoDoc === 8)?.noProcede === 1 ? (
                      <span style={{ color: "#000" }}>{t('detail.notApplicable')}</span>
                    ) : (
                      <>
                        {proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                          ?.pendiente &&
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                            ?.status ? (
                          <CustomPendienteSwitch
                            checked={false}
                            onClick={() =>
                              comprobarValidacion(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.id,
                                proveedor.nif,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.type?.id
                              )
                            }
                          />
                        ) : (
                          <CustomSwitch
                            checked={
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                ?.validado &&
                              proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                ?.status
                            }
                            onClick={() =>
                              comprobarArchivos(
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.validado,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.status,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.ruta,
                                proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                                  ?.id,
                                8,
                                user.rol,
                                proveedor.nif,
                                proveedor?.noProcede
                              )
                            }
                          />
                        )}
                        <small style={{ display: "block" }}>
                          {proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                            ?.fechaCaducidad !== null &&
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 8)
                              ?.status ? (
                            <span
                              style={{
                                color:
                                  daysDiff(
                                    new Date(
                                      proveedor?.docssupps?.find(
                                        (d) => d.tipoDoc === 8
                                      )?.fechaCaducidad
                                    ),
                                    new Date()
                                  ) > 0
                                    ? "red"
                                    : "black",
                              }}
                            >
                              {new Date(
                                proveedor?.docssupps?.find(
                                  (d) => d.tipoDoc === 8
                                )?.fechaCaducidad
                              ).toLocaleDateString()}
                            </span>
                          ) : (
                            "-"
                          )}
                        </small>
                      </>
                    )}
                  </td>
                  {/* Certificado Seg. Social */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                      ?.pendiente ? (
                      <CustomPendienteSwitch
                        checked={false}
                        onClick={() =>
                          comprobarValidacion(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.id,
                            proveedor.nif,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.type?.id
                          )
                        }
                      />
                    ) : (
                      <CustomSwitch
                        checked={
                          proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                            ?.validado
                        }
                        onClick={() =>
                          comprobarArchivos(
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.validado,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.status,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.ruta,
                            proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                              ?.id,
                            6,
                            user.rol,
                            proveedor.nif
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>
                      {proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                        ?.fechaCaducidad !== null &&
                        proveedor?.docssupps?.find((d) => d.tipoDoc === 6)
                          ?.fechaCaducidad !== undefined ? (
                        <span
                          style={{
                            color:
                              daysDiff(
                                new Date(
                                  proveedor?.docssupps?.find(
                                    (d) => d.tipoDoc === 6
                                  )?.fechaCaducidad
                                ),
                                new Date()
                              ) > 0
                                ? "red"
                                : "black",
                          }}
                        >
                          {new Date(
                            proveedor?.docssupps?.find(
                              (d) => d.tipoDoc === 6
                            )?.fechaCaducidad
                          ).toLocaleDateString()}
                        </span>
                      ) : (
                        "-"
                      )}
                    </small>
                  </td>
                  {/* Declaracion Responsable */}
                  <td style={{ textAlign: "center" }}>
                    {proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.pendiente ? (
                      <CustomPendienteSwitch
                        checked={false}
                        // onClick={() => abrirArchivo(proveedor?.declres?.find( d => d.aaff_id === aaff.id )?.ruta)}
                        onClick={() => comprobarValDeclRes(proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.ruta, proveedor?.declres?.find(d => d.aaff_id === aaff.id).id, aaff.nif)}
                      />
                    ) : (
                      <CustomSwitch
                        checked={proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.validado}
                        onClick={
                          () => comprobarDeclRes(
                            proveedor?.nif,
                            aaff.id,
                            aaff.nif,
                            proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.ruta,
                            proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.id,
                            proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.validado,
                            proveedor?.declres?.find(d => d.aaff_id === aaff.id)?.status,
                          )
                        }
                      />
                    )}
                    <small style={{ display: "block" }}>-</small>
                  </td>
                </tr>}
              </tbody>
            </table>
            {proveedor?.noProcede !== true && (
              <Trabajadores nifSupp={proveedor.nif} crear={true} fechaCaducidad={true} recargar={recargar} />
            )}
            <input type="file" id="fileElem" hidden></input>
          </div>
        </div>
        <div className="gridCard">
          <div className="gridHead">
            <span>{t('properties:title').toUpperCase()}</span>
            {!loadingXls ? (
              <img
                src={Excel}
                alt="Exportar Excel"
                style={{
                  filter: 'brightness(0) invert(1)',
                  cursor: 'pointer', // Cambia el icono del mouse
                  transition: 'transform 0.2s ease' // Suaviza el efecto de hover
                }}
                onClick={() => generateComunidadesExcel(proveedor.id)}
                // Opcional: un pequeño efecto visual al pasar el mouse
                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            ) : (
              <CircularProgress
                style={{ color: '#fff', width: '16px', height: '16px', marginRight: '10px' }}
              />
            )}
          </div>
          <ControlledAccordions
            aaff={aaff}
            proveedor={proveedor}
            fincas={fincas}
          />
        </div>
        <div className="gridCard" /* style={delegations > 0 ? { display: 'block' } : { display: 'none' }} */>
          <div className="gridHead">
            {proveedor.parent_id !== null ? t('parentSupplier') : t('delegations.title').toUpperCase()}
            {proveedor.parent_id === null &&
              <Link to={`/delegacion/nueva/${proveedor.id}`} >
                <div className="gridHeadRight">
                  <img src={Add} alt={t('common:actions.more')} width={15} />
                </div>
              </Link>
            }
          </div>
          <table style={{ margin: 15 }}>
            <thead>
              <tr
                style={{
                  fontSize: 10,
                  fontWeight: "normal",
                  textAlign: "center",
                }}
              >
                <th></th>
                {/* <th>Aviso</th> */}
              </tr>
            </thead>
            <tbody>
              <Delegations nif={props.params.nifProveedor} proveedor={proveedor} redirectToSomeRoute={redirectToSomeRoute} />
            </tbody>
          </table>
        </div>
      </div>
      {dialog.open === 1 && (
        <DialogoSubirDocumentacion
          open={dialog.open}
          proveedor={proveedor}
          dialog={dialog}
          hijoAPadre={hijoAPadre}
        />
      )}
      <style jsx="true">{`
          .pageGrid {
            position: relative;
            top: 00px;
            margin: 0 10px;
            display: grid;
            grid-template-columns: 5fr 3fr;
            grid-gap: 20px;
          }                
      `}</style>
    </>
    ;
};

export default withRouter(Proveedor);